// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"home"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 10L12 2.5L21 10V21H3V10Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 14H15V21H9V14Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 14H15V21H9V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 10L12 2.5L21 10V21H3V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HomeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'home',
    ref,
    icon: element,
  },
));

HomeIcon.displayName = 'HomeIcon';

export default HomeIcon;
